export default "__VITE_ASSET__BAlnJOGe__"